import { Controller } from '@hotwired/stimulus';
import { needsToBeAsked, accepts, rejectsAll } from 'src/lib/cmp_cookies';

export default class extends Controller {
  connect() {
    if (needsToBeAsked()) {
      this.show();
    }
  }

  clickAcceptAll(e) {
    e.preventDefault();

    accepts({ all: true });
    this.hide();
  }

  clickRejectAll(e) {
    e.preventDefault();

    rejectsAll();
    this.hide();
  }

  show() {
    this.element.style.display = 'flex';
  }

  hide() {
    this.element.style.display = 'none';
  }

  beforeCache() {
    this.hide();
  }
}
